import React from "react";
import { formatNumberOnDashBoard } from "../../helper";

export const modifyDashboardSummaryData = summaryData => {
  if (Object.keys(summaryData) && Object.keys(summaryData).length) {
    for (let key in summaryData) {
      if (summaryData.hasOwnProperty(key)) {
        let value = summaryData[key];
        let { total, open, resolved } = value;

        let getCost = obj => {
          let parsedCost =
            obj && formatNumberOnDashBoard(parseInt(obj.projectCost), false);
          //let parsedCost = obj && parseInt(obj.projectCost);
          return parsedCost ? `${parsedCost} Cr.` : "";
        };
        let openBifurcationObj =
          key === "pragatiReview"
            ? {
                "Open Issues": open.issue,
                "Project Value": getCost(open)
              }
            : { "Open Issues": open.issue };

        let resolvedBifurcationObj =
          key === "pragatiReview"
            ? {
                "Resolved Issues": resolved.issue,
                "Project Value": getCost(resolved)
              }
            : key === "projectCount"
            ? {
                "Resolved Issues": resolved.issue
              }
            : {
                Projects: resolved.project,
                "Project Value": getCost(resolved)
              };

        if (key !== "projectCost") {
          open.count = key === "issueCount" ? open.count : open.project;
          resolved.count =
            key === "issueCount" ? resolved.issue : resolved.project;
          open.bifurcation =
            key === "issueCount" ? open.bifurcation : openBifurcationObj;
          resolved.bifurcation = resolvedBifurcationObj;
        }
      }
    }

    return summaryData;
  }
  return {};
};
